import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByRelevance'
})
export class SortByRelevancePipe implements PipeTransform {
  transform(values: any[], match: string, property?: string): any[] {
    const searchStr = match.toLowerCase();
    return values.sort((a, b) => {
      if (property) {
        a = a[property];
        b = b[property];
      }
      return a.toLowerCase().indexOf(searchStr) < b.toLowerCase().indexOf(searchStr) ? -1 : 1;
    });
  }
}
